var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgNavKeywordResearch = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 20,
  height: 20,
  viewBox: "0 0 20 20",
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M11.267 5.517c-.5 0-.9.4-.9.9s.4.9.9.9c.783 0 1.433.65 1.433 1.433 0 .5.4.9.9.9s.9-.4.9-.9a3.236 3.236 0 0 0-3.233-3.233Z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "m2.367 16.217 3.55-3.534a6.602 6.602 0 0 1-1.3-3.95 6.658 6.658 0 0 1 6.65-6.65 6.658 6.658 0 0 1 6.65 6.65 6.658 6.658 0 0 1-6.65 6.65 6.638 6.638 0 0 1-3.95-1.3l-3.534 3.534c-.2.2-.45.283-.7.283a1.014 1.014 0 0 1-.921-.6.982.982 0 0 1 .205-1.083Zm13.566-7.484a4.68 4.68 0 0 0-4.666-4.666A4.68 4.68 0 0 0 6.6 8.733a4.68 4.68 0 0 0 4.667 4.667 4.67 4.67 0 0 0 4.666-4.667Z"
})));
SvgNavKeywordResearch.displayName = "SvgNavKeywordResearch";
export { SvgNavKeywordResearch as ReactComponent };
export default SvgNavKeywordResearch;